import { CloudUploadOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import clsx from 'clsx';
import { type DragEvent, type ReactNode, useState } from 'react';
import styles from './AttachmentsDropzone.module.scss';

const { Text } = Typography;

const PASTE_MODIFIER = /Mac|iPhone|iPad/.test(navigator.userAgent) ? '⌘' : 'Ctrl';

type Props = {
  title: string;
  hint: ReactNode;
  disabled?: boolean;
  onOpen: () => void;
  onDrop: (files: File[]) => void;
};

export const AttachmentsDropzone = ({ title, hint, disabled, onOpen, onDrop }: Props) => {
  const [dragging, setDragging] = useState(false);

  const onDragOver = (e: DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!disabled) setDragging(true);
  };

  const onDropFiles = (e: DragEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setDragging(false);
    if (!disabled) onDrop(Array.from(e.dataTransfer.files));
  };

  return (
    <button
      type="button"
      disabled={disabled}
      className={clsx(styles.zone, dragging && styles.dragging, disabled && styles.disabled)}
      onClick={onOpen}
      onDragOver={onDragOver}
      onDragLeave={() => setDragging(false)}
      onDrop={onDropFiles}
    >
      <CloudUploadOutlined className={styles.icon} />
      <Text strong>{title}</Text>
      <Text type="secondary" className={styles.caption}>
        Click or drag files here, or press <Text keyboard>{PASTE_MODIFIER}</Text>+<Text keyboard>V</Text> to paste from
        your clipboard
      </Text>
      <Text type="secondary" className={styles.hint}>
        {hint}
      </Text>
    </button>
  );
};
